import {apiLogin, apiUserInfo,apiLoginOut} from '@/api/user'

const getDefaultState = () => {
  return {
    token: '',
    userInfo:{},
    avatar: '',
    feedNav: false,
    EncodeUserInfo: localStorage.getItem('EncodeUserInfo')
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    // localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_FEEDNAV: (state, val) => {
    state.feedNav = val
  },
  SET_ENCODEUSERINFO: (state, val) => {
    state.EncodeUserInfo = val
    localStorage.setItem('EncodeUserInfo', val)
  }
}

const actions = {
  // user login
  login({commit}, data) {
    return new Promise((resolve, reject) => {
      commit('SET_NAME', data.userName)
      resolve('success')
      // apiLogin(data).then(response => {
      //   const { data } = response
      //   console.log('31----',data)
      //   data.token = 'test_token'
      //   commit('SET_TOKEN', data.token)
      //   commit('SET_NAME', data.username)
      //   localStorage.setItem('token', data.token)
      //   resolve(response)
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // get user info
  getInfo({commit, state}) {
    // console.log('state.token',state.token)
    return new Promise((resolve, reject) => {
      apiUserInfo().then(response => {
        const {userInfo, userCustomize,EncodeUserInfo} = response.Rows
        const userInfoStrEncode = response.userInfoStrEncode
        if(userCustomize && userCustomize.customizeValues){
         let customize =  JSON.parse(userCustomize.customizeValues).DCpermission || 0
          userInfo['customizeValues'] = customize
        }else{
          userInfo['customizeValues'] = 0
        }
        console.log('54----', userInfo)
        console.log('userInfoStrEncode', userInfoStrEncode)
        const Rows = userInfo
        commit('SET_USERINFO', Rows)
        commit('SET_ENCODEUSERINFO', userInfoStrEncode)
        resolve(Rows)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 退出
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      apiLoginOut().then(response => {
        console.log('out', response)
        localStorage.clear()
        commit('RESET_STATE')
        resolve('success')
      }).catch(error => {
        // console.log('out-----', error)
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js